const success = (message, action = "updated") => ({
  message,
  type: "success",
  action,
});

const warning = (message, action = "updated") => ({
  message,
  type: "warning",
  action,
});

const danger = (message, action = "error") => ({
  message,
  type: "danger",
  action,
});

const recordLabel = (target) => target?.label || "Record";
const recordNoun = (target) => target?.label || "record";

export const payoutRunToasts = {
  loadRunError: () => danger("Could not load payout run."),
  invalidAdjustmentUpdate: () =>
    danger("Could not identify adjustment to update."),
  adjustmentSaveError: (mode) =>
    danger(
      mode === "edit"
        ? "Could not update agent adjustment."
        : "Could not add agent adjustment.",
    ),
  invalidAdjustmentDelete: () =>
    danger("Could not identify adjustment to delete."),
  adjustmentDeleted: () => ({
    message: "Agent adjustment deleted.",
    type: "danger",
    action: "delete",
  }),
  adjustmentDeleteError: () => danger("Could not delete agent adjustment."),
  approveError: (target) => danger(`Could not approve ${recordNoun(target)}.`),
  declineError: (target) => danger(`Could not decline ${recordNoun(target)}.`),
  adjustError: (target) => danger(`Could not adjust ${recordNoun(target)}.`),
  removeSuccess: (target) =>
    warning(`${recordLabel(target)} removed from payout run.`),
  removeError: (target) =>
    danger(`Could not remove ${recordNoun(target)} from payout run.`),
  reopenError: (target) => danger(`Could not reopen ${recordNoun(target)}.`),
  runDecisionSuccess: (action) =>
    success(
      action === "decline"
        ? "Payout run declined: all commissions and bonuses were declined."
        : `Payout run ${action}d: all pending commissions and bonuses were ${action}d.`,
    ),
  runDecisionError: (action) => danger(`Could not ${action} payout run.`),
  invalidAgentForAdjustment: () =>
    danger("Agent adjustment requires a valid agent."),
  reportRequestSuccess: () =>
    success("Commission report downloaded.", "downloaded"),
  reportTypeLoadError: () => danger("Could not load commission report types."),
  reportRequestError: () => danger("Could not download commission report."),
  addContractSuccess: () => success("Contract added to payout run.", "added"),
  addContractError: () => danger("Could not add contract to payout run."),
};
